<section class="unsaved-changes-body">
  <app-dialog-close-button class="unsaved-changes-close" (closed)="onCancel()"></app-dialog-close-button>

  <vng-icon class="unsaved-changes-icon" name="warning" color="error" [outline]="false"></vng-icon>

  <h2 class="unsaved-changes-title">Unsaved Changes</h2>

  <p class="unsaved-changes-message">
    You have unsaved changes in:
    <strong>{{ data.dirtySections.join(', ') }}</strong>
  </p>

  <div class="unsaved-changes-actions">
    <button type="button" vng-button variant="secondary" (click)="onCancel()">Cancel</button>
    <button type="button" vng-button variant="destructive" (click)="onDiscard()">Discard</button>
    <button type="button" vng-button variant="brand" (click)="onSave()">Save</button>
  </div>
</section>
